"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";
import { whyChooseItems } from "./brokerage.data";
import GradientButton from "@/components/ui/GradientButton";
import { FaChevronRight } from "react-icons/fa";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
const PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='520' height='420'%3E%3Crect width='520' height='420' rx='18' fill='%23ffffff' fill-opacity='0.4'/%3E%3C/svg%3E";
export default function ScaleBanner() {
  const $ = _c(36);
  const desktopAnimations = useDesktopAnimations();
  let t0;
  if ($[0] !== desktopAnimations) {
    t0 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== desktopAnimations) {
    t1 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== desktopAnimations) {
    t2 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: 0.6,
      ease
    };
    t4 = {
      once: true
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2) {
    t5 = <motion.h2 initial={t0} whileInView={t1} animate={t2} transition={t3} viewport={t4} className="font-poppins mb-6 max-w-[620px] text-[30px] font-bold leading-[1.4] text-[#0b1354] sm:text-[36px] lg:text-[40px] dark:text-white">{"Streamline & Scale Your Order Brokerage Business with Ease"}</motion.h2>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="mb-9 max-w-[520px] text-[16px] leading-[30px] text-[#6b7280] lg:text-[17px] dark:text-gray-400">Effortlessly manage and optimize your order brokerage operations with our expert solutions. Our platform provides everything you need to enhance efficiency, boost profits, and ensure seamless transactions.</p>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="mb-12"><GradientButton href="/contact" variant="peach-pink">Talk to an expert <FaChevronRight className="ml-1 text-[12px]" /></GradientButton></div>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== desktopAnimations) {
    t8 = desktopAnimations ? {
      opacity: 0
    } : false;
    $[14] = desktopAnimations;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== desktopAnimations) {
    t9 = desktopAnimations ? {
      opacity: 1
    } : undefined;
    $[16] = desktopAnimations;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== desktopAnimations) {
    t10 = desktopAnimations ? undefined : {
      opacity: 1
    };
    $[18] = desktopAnimations;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      duration: 0.6
    };
    t12 = {
      once: true
    };
    $[20] = t11;
    $[21] = t12;
  } else {
    t11 = $[20];
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t8 || $[24] !== t9) {
    t13 = <motion.img initial={t8} whileInView={t9} animate={t10} transition={t11} viewport={t12} src="/images/brokerage/two-person.png" alt="Team managing brokerage orders and invoices" loading="lazy" className="w-full max-w-[520px] object-contain" onError={_temp} />;
    $[22] = t10;
    $[23] = t8;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13 || $[27] !== t5) {
    t14 = <div className="flex flex-col">{t5}{t6}{t7}{t13}</div>;
    $[26] = t13;
    $[27] = t5;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== desktopAnimations) {
    t15 = whyChooseItems.map((item, idx) => <motion.div key={item.title} initial={desktopAnimations ? {
      opacity: 0,
      y: 24
    } : false} whileInView={desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined} animate={desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: idx * 0.08,
      ease
    }} viewport={{
      once: true
    }} className={"\n              group relative rounded-[10px] bg-[#f1f8fd]\n              px-5 py-6 pl-6\n              shadow-[0_6px_24px_-14px_rgba(13,38,76,0.28)]\n              transition-all duration-300\n              hover:-translate-y-1 hover:bg-white\n              hover:shadow-[0_16px_40px_-18px_rgba(13,38,76,0.45)]\n              sm:pl-7\n              dark:bg-gray-800 dark:hover:bg-gray-750 dark:shadow-[0_6px_24px_-14px_rgba(0,0,0,0.5)]\n              "}><span className={"\n                absolute -left-3.5 top-1/2\n                flex h-8 w-8 -translate-y-1/2\n                items-center justify-center\n                rounded-full border border-[#f5497e]\n                bg-white text-[14px]\n                font-semibold text-[#f5497e]\n                shadow-[0_2px_8px_-2px_rgba(13,38,76,0.2)]\n                transition-transform duration-300\n                group-hover:scale-110\n                dark:bg-gray-900\n                "}>{idx + 1}</span><div className="flex items-start gap-[22px]"><div className={"\n                  flex h-[55px] w-[55px]\n                  flex-shrink-0 items-center justify-center\n                  transition-transform duration-300\n                  group-hover:scale-110\n                  "}><Image src={item.image} alt={item.title} width={55} height={55} className="h-[55px] w-[55px] object-contain" /></div><div><h3 className={"\n                    font-poppins mb-2\n                    text-[20px] font-bold\n                    leading-[28px] text-[#0b1354]\n                    dark:text-white\n                    "}>{item.title}</h3><p className={"\n                    text-[16px]\n                    leading-[30px]\n                    text-[#6b7280]\n                    lg:text-[17px]\n                    dark:text-gray-400\n                    "}>{item.description}</p></div></div></motion.div>);
    $[29] = desktopAnimations;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = <div className="space-y-[35px] lg:pl-5">{t15}</div>;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t14 || $[34] !== t16) {
    t17 = <section className="overflow-hidden bg-[linear-gradient(to_bottom,#DBF2FF_10%,#FFFFFF_100%)] px-6 py-16 font-sans md:py-24 dark:bg-gray-950 dark:bg-none"><div className="mx-auto grid w-full max-w-[1290px] grid-cols-1 gap-14 lg:grid-cols-2 lg:items-start lg:gap-12">{t14}{t16}</div></section>;
    $[33] = t14;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  return t17;
}
function _temp(e) {
  e.currentTarget.onerror = null;
  e.currentTarget.src = PLACEHOLDER;
}